import {
    GET_DYNAMIC_LIST_TITLE_START,
    GET_DYNAMIC_LIST_TITLE_ERROR,
    GET_DYNAMIC_LIST_TITLE_SUCCESS
} from "../../constants";
import { getAllDynamicListTitle as query } from '../../lib/graphql';

const getDynamicListTitles = ({ locale }) => {
    return async (dispatch, getState, { client }) => {

        dispatch({ type: GET_DYNAMIC_LIST_TITLE_START });

        try {
            const { data } = await client.query({
                query,
                variables: { locale },
                fetchPolicy: 'network-only'
            });

            if (data?.getAllDynamicListTitle?.status == 200) {

                await dispatch({
                    type: GET_DYNAMIC_LIST_TITLE_SUCCESS,
                    payload: {
                        dynamicListTitle: data?.getAllDynamicListTitle?.results?.dynamicListTitle,
                        dynamicListDescription: data?.getAllDynamicListTitle?.results?.dynamicListDescription,
                        dynamicCancellationData: data?.getAllDynamicListTitle?.results?.dynamicCancellationData
                    }
                });

            }

        } catch (error) {
            dispatch({
                type: GET_DYNAMIC_LIST_TITLE_ERROR,
                payload: { error }
            });
        }
    }
}

export default getDynamicListTitles;